import React from "react";
import { twoDecimalFormatter } from "halifax";

export const HEADER_MAIN_TEXT = "Confirm and book";
export const HEADER_SUB_TEXT = "Enter all required details";

export const FLIGHT_TRAVELERS_HEADING = "Step 1: Who's flying?";
export const HOTEL_TRAVELERS_HEADING = "Step 2: Who’s checking in?";
export const SEAT_SELECTION_HEADING = "Step 3: Seat selection";
export const PAYMENT_HEADING = (showRewards: boolean) =>
  showRewards ? "Step 4: Rewards and payment" : "Step 4: Payment";
export const PAYMENT_SUBHEADING =
  "Combine travel offers, travel credits, rewards, and your Capital One credit card to book this trip";

export const LOADING_TEXT = "Loading";

export const CHANGE_CTA_TEXT = "Change";
export const CHANGE_WHO_FLYING = "Change who's flying";
export const CHANGE_WHO_CHECKING_IN = "Change who's checking in";

export const SELECTED_SEATS_COMPLETED_TEXT = (
  numPassengers: number,
  seatsTotal: number
) => (
  <>
    You’ve reserved seats for ({numPassengers}) passenger
    {numPassengers === 1 ? "" : "s"} for{" "}
    <strong>${twoDecimalFormatter(seatsTotal)}</strong>
  </>
);
export const SKIPPED_SEATS_COMPLETED_TEXT = "You've skipped seat selection";
export const SEAT_SELECTION_NOT_AVAILABLE =
  "Seat selection is currently unavailable for your journey.";

export const SELECTED_PAX_DIFFERS_FROM_SEARCHED_BANNER_TEXT = (
  isFewer: boolean
) =>
  `You’ve added ${
    isFewer ? "fewer" : "more"
  } travelers than originally searched for. The total price will update after you complete this step.`;

export const PAYMENT_EARN_INFO_TOOLTIP_TEXT =
  "You will only earn rewards on the amount paid with your Capital One credit card, not including credits and/or rewards redeemed for your booking.";
